import { graphql } from 'gatsby';
import React from 'react';
import HeroSubmenu, { hasSubmenu } from '../../fragments/hero-submenu';
import { useImageLoaded } from '~/hooks/useImage';
import { cn, getParentPageSubmenu, trimText } from '~/utils/helpers';

const BlogHero: React.FC<{
  block: any;
  parentPage: any;
  data: BlogPost | FeaturedPost;
}> = ({ block, parentPage, data }) => {
  const [ref, loaded, onLoad] = useImageLoaded();
  const MAX_EXCERPT_LENGTH = 260;
  const trimmedExcerpt = trimText(data.excerpt, MAX_EXCERPT_LENGTH);
  const submenuField = block.submenu_field
    ? block.submenu_field
    : getParentPageSubmenu(parentPage);
  const submenuClass = hasSubmenu(submenuField) ? 'has-submenu' : '';
  const parentTitle = submenuField.menu_group_title;
  const {
    menu_items: [rootMenuItem],
  } = submenuField;

  return (
    <section
      className={cn(
        `block ${block._template} ${block.css_class_name} ${submenuClass} block-hero--simple`
      )}
    >
      <div className='container'>
        <HeroSubmenu
          block={submenuField}
          parentTitle={parentTitle}
        />
        <div className='row'>
          <h1 className='blog-hero__title'>{block.title}</h1>
          <a
            className='hero-link-decoration'
            href={`${rootMenuItem.menu_url}${data.slug}`}
          >
            <div className='blog-hero-field'>
              <div className='blog-image'>
                <img
                  ref={ref}
                  className={`blog-hero-field__image ${loaded ? 'loaded' : ''}`}
                  src={data.feature_image}
                  alt={''}
                  onLoad={onLoad}
                  loading='lazy'
                />
              </div>
              <h3 className='blog-intro__category text-orange-gradient'>
                {data.primary_tag?.name}
              </h3>
              <h2 className='blog-intro__title'>{data.title}</h2>
              <p className='blog-intro__description'>{trimmedExcerpt}</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export const BlogHeroFragmentQuery = graphql`
  fragment BlogHeroFragment on Block {
    title
    blog_item {
      category
      title
      description
      image
      image_alt_text
    }
  }
`;

export default BlogHero;
